import { useState } from "react";
import { toast } from "sonner";
import { Send, FileSignature } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ElleNoDialog } from "@/components/ElleNoDialog";
import api, { errMsg } from "@/lib/api";

export const EIrsaliyeDialog = ({ v, onClose, onSaved }) => {
  const [elle, setElle] = useState(false);
  const [busy, setBusy] = useState(false);
  const gonder = async (body) => {
    setBusy(true);
    try { const { data } = await api.post(`/sevkiyatlar/${v.id}/e-irsaliye`, body); toast.success(`e-İrsaliye ${data.belge_no}`); onSaved(); } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  if (elle) return <ElleNoDialog baslik={`${v.no} · elle e-İrsaliye no`} onClose={onClose} onSave={gonder} />;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-md" data-testid="eirsaliye-dialog">
        <DialogHeader><DialogTitle className="font-head">{v.no} · e-İrsaliye</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{v.cari_unvan} · {v.kalemler?.length || 0} kalem</p>
        <div className="grid gap-2">
          <button disabled={busy} onClick={() => gonder({ elle: false })} data-testid="eirsaliye-gonder" className="flex items-center gap-3 rounded-xl border border-white/10 p-4 text-left hover:bg-white/5 disabled:opacity-50">
            <Send className="w-5 h-5 text-[var(--g1)]" /><div><div className="text-sm font-medium">QNB ile gönder</div><div className="text-xs text-muted-foreground">1 kontör düşer</div></div></button>
          <button onClick={() => setElle(true)} data-testid="eirsaliye-elle" className="flex items-center gap-3 rounded-xl border border-white/10 p-4 text-left hover:bg-white/5">
            <FileSignature className="w-5 h-5" /><div><div className="text-sm font-medium">Elle numara gir</div><div className="text-xs text-muted-foreground">Portaldan kesildiyse; kontör düşmez</div></div></button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
